var _a;
import { I18nLangs } from "./enums/i18-langs";
export var ANDROID_B2B_LINK = "https://play.google.com/store/apps/details?id=tools.gad24.app&hl=de_CH";
export var IOS_B2B_LINK = "https://apps.apple.com/ch/app/gad24-app/id1510948466";
export var TERMS_OF_SERVICE = "https://pixel24.world/en/terms-and-conditions/";
export var PRIVATE_POLICY = "https://pixel24.world/en/datenschutz/";
export var LICENSES = "https://pixel24.world/en/impressum/";
export var MAX_WAIT_ALIVE = 2 * 60 * 1000;
export var MAX_IMAGE_WIDTH = 1440 * 3;
export var MAX_IMAGE_HEIGHT = 1080 * 3;
export var MIN_IMAGE_WIDTH = 1280;
export var MIN_IMAGE_HEIGHT = 720;
export var DEFAULT_LANG = I18nLangs.EN;
export var LANG_ORDER = (_a = {},
    _a[I18nLangs.EN] = 0,
    _a[I18nLangs.DE] = 1,
    _a[I18nLangs.CS] = 2,
    _a[I18nLangs.FR] = 3,
    _a[I18nLangs.IT] = 4,
    _a[I18nLangs.PL] = 5,
    _a[I18nLangs.PT] = 6,
    // [I18nLangs.UK]: 7,
    _a[I18nLangs.ES] = 7,
    _a[I18nLangs.SK] = 8,
    _a[I18nLangs.SL] = 9,
    _a);
export var mapRoleIdToRoleName = function (roleId) {
    var map = new Map([
        ['5caaef1a1d50f8270cdd75d5', 'customer'],
        ['5caaef2a1d50f8270cdd75d6', 'qa'],
        ['5caaef2f1d50f8270cdd75d7', 'dealer'],
        ['5caaef361d50f8270cdd75d8', 'admin'],
        ['5caaef3a1d50f8270cdd75d9', 'designer'],
    ]);
    return map.get(roleId) || 'customer';
};
